/* eslint-disable */
// Generated by deployment/generate-cognito-config.js — do not edit.

const cognitoConfig = {
  "region": "us-east-1",
  "userPoolId": "us-east-1_hXrwxXuuU",
  "userPoolWebClientId": "5k6gmticgjhqtq1lg78ttah6n0",
  "identityPoolId": "us-east-1:849d35c0-463d-4104-8e29-dc54a5995d27",
  "oauth": {
    "domain": "sg-access-team-auth.auth.us-east-1.amazoncognito.com",
    "scope": [
      "phone",
      "email",
      "openid",
      "profile",
      "aws.cognito.signin.user.admin"
    ],
    "redirectSignIn": "https://team.signalwise.io",
    "redirectSignOut": "https://team.signalwise.io",
    "responseType": "code"
  }
};

export default cognitoConfig;
